import PLANS_PATH from '../../constants/path'
import getRecommendedByIdPlanSelector from '../get-recommended-by-id'
import getByIdPropReduxSelector from '../../../redux/selectors/get-by-id-prop'

function getByIdPlanSelector (id) {
  return (state, props) => {
    return (
      getByIdPropReduxSelector(PLANS_PATH.DATA)(state, { id }) ||
      getRecommendedByIdPlanSelector(id)(state, props)
    )
  }
}

export default getByIdPlanSelector
